var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIotxWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4541 4.375V9.14987L18.5998 6.7655L14.4541 4.375Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M18.5996 6.7655V11.5404L22.7444 9.14987L18.5996 6.7655Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.4541 9.1499V13.9248L18.5998 11.5404L14.4541 9.1499ZM18.5998 11.5413V16.3153L22.7448 13.9248L18.5998 11.5413Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.4541 13.9247V18.6997L18.5998 16.3153L14.4541 13.9247Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5996 16.3152V21.0902L22.7444 18.6997L18.5996 16.3152Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.73926 8.98889V13.7638L7.88501 11.3733L3.73926 8.98889Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8.96875 10.7643V15.5392L13.1075 13.1548L8.96875 10.7643Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M5.89551 13.7839V18.5587L10.0404 16.1682L5.89551 13.7839Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M8.62793 17.3871V22.162L12.7667 19.7715L8.62793 17.3871Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M14.4199 19.4425V24.2183L18.5587 21.8268L14.4199 19.4425Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M9.65918 8.40613V13.1819L13.7979 10.7975L9.65918 8.40613Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M14.4544 4.375V9.14987L10.3086 6.7655L14.4544 4.375Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.65933 6.40503V11.179L5.5127 8.78853L9.65933 6.40503Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.8049 8.76746V13.5432L9.65918 11.1518L13.8049 8.76746Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M8.94946 10.7643V15.5392L4.80371 13.1548L8.94946 10.7643Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M14.4542 13.9247V18.6997L10.3154 16.3153L14.4542 13.9247Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M5.89575 15.0369V19.8118L1.75 17.4204L5.89575 15.0369Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7444 9.1499V13.9248L18.5996 11.5404L22.7444 9.1499Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    d: "M18.5998 11.5413V16.3153L14.4541 13.9248L18.5998 11.5413Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M22.7444 13.9247V18.6997L18.5996 16.3153L22.7444 13.9247Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M18.5998 16.3152V21.0902L14.4541 18.6997L18.5998 16.3152Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.5365 18.305V23.0798L9.3916 20.6955L13.5365 18.305Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5998 6.7655V11.5404L14.4541 9.14987L18.5998 6.7655Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotxWhite);
export default __webpack_public_path__ + "static/media/iotx-white.e4c3233f53c9a2ca0c560a5ae4e80e1b.svg";
export { ForwardRef as ReactComponent };